import { render, staticRenderFns } from "./poi-text-audio.vue?vue&type=template&id=2989da29&"
import script from "./poi-text-audio.vue?vue&type=script&lang=ts&"
export * from "./poi-text-audio.vue?vue&type=script&lang=ts&"
import style0 from "./poi-text-audio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports